/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { fetchAppealLitigationByAppealSummonId } from "services/prosecutorDecipilineService";
import AppealLitigationCard from "./AppealLitigationCard";
import { useTranslation } from "contexts/i18nContext";

interface DetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  complaintData: any;
  appealData: any;
}

const HearingHistoryModal: React.FC<DetailModalProps> = ({
  isOpen,
  onClose,
  appealData,
  complaintData,
}) => {
  const { t } = useTranslation();
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  const [litigationData, setLitigationData] = useState<any[]>([]);
  const modalRef = useRef<HTMLDivElement | null>(null);

  const loadCourtAppealLitigation = useCallback(async () => {
    if (!complaintData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(
        complaintData?.uu_id || "",
      );
      if (resData)
        setLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.appeal_request?.toString() === appealData?.id?.toString(),
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, appealData]);

  useEffect(() => {
    loadCourtAppealLitigation();
  }, [complaintData, appealData]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !appealData) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div
        ref={modalRef}
        className="bg-gray-50 rounded-2xl shadow-xl w-full max-w-4xl mx-4 p-6 max-h-[80vh] overflow-y-auto"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            {t("dailyHearingHistory")}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-2xl"
          >
            &times;
          </button>
        </div>

        {litigationData.length <= 0 && (
          <h5>{t("noDailyHearingHistoryFound")}</h5>
        )}

        {litigationData && litigationData.length > 0 && (
          <AppealLitigationCard
            litigationData={litigationData}
            councilLitigationData={[]}
            onLitigationRefresh={loadCourtAppealLitigation}
          />
        )}
      </div>
    </div>
  );
};

export default HearingHistoryModal;
